import { type FC } from 'react';
import styles from './index.module.scss';
import Marquee from 'react-fast-marquee';
// import { usePumpTradePresent } from '@hooks/use-pump-trade';
// import { formatAddress } from '@mysten/sui/utils';
import type { OpenapiClientPump } from 'src/openapi/pump';
import { Link } from 'react-router-dom';
import { usePumpRankingChanges } from '@hooks/use-pump-ranking-changes';

export const Top: FC = () => {
  const { rankingChanges } = usePumpRankingChanges();
  if (!rankingChanges || rankingChanges.length < 1) return null;
  return (
    <div className={styles.top}>
      <Marquee
        direction="left" // 设置滚动方向为左
        speed={75} // 设置滚动速度
        gradient={false} // 关闭渐变效果（根据需要）
        pauseOnHover={true}
        className={styles.marquee}
      >
        {rankingChanges.map((item, index) => (
          <List data={item} key={item.token_address} index={index} />
        ))}
      </Marquee>
    </div>
  );
};

const List: FC<{ data: OpenapiClientPump.GetRankingsChangesResponse[number]; index: number }> = ({
  data,
  index,
}) => {
  return (
    <Link to={`/fun/${data.token_address}`}>
      <div className={styles.items}>
        <span>#{index + 1}</span>
        <img src={data.token_metadata?.iconUrl || ''} />
        <span>{data.token_metadata.symbol}</span>
        <span className={styles.changes}>+{Number(data.change_24h.toFixed(2))}%</span>
      </div>
    </Link>
  );
};

export default Top;
